import React from 'react';
import { FilterRenderer } from './FilterRenderer';
export function HeaderRenderer(_ref) {
  let {
    column,
    sortDirection,
    onSort,
    filters,
    onFilterChange,
    showFilter = true
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '4px 8px',
      cursor: column.sortable ? 'pointer' : 'default',
      flex: 1
    },
    onClick: column.sortable ? onSort : undefined
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 600
    }
  }, column.name), column.sortable && /*#__PURE__*/React.createElement(React.Fragment, null, sortDirection?.toLowerCase() === 'asc' && /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "arrow_drop_up"), sortDirection?.toLowerCase() === 'desc' && /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "arrow_drop_down"), !sortDirection && /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "sort"))), showFilter && /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '0 4px 4px 4px'
    }
  }, /*#__PURE__*/React.createElement(FilterRenderer, {
    column: column,
    filters: filters,
    onFilterChange: onFilterChange
  })));
}